import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { formInputTheme, getBackgroundColor } from "../../textinput/styled/formInputTheme";
export var TextAreaStyled = styled("textarea")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n    max-height: ", ";\n    word-break: break-word;\n\n    // needed to position the error message correctly\n    min-height: ", ";\n\n    padding: ", ";\n\n    resize: none;\n    color: inherit;\n    &::placeholder {\n        color: ", ";\n    }\n    &[aria-disabled=\"true\"] {\n        cursor: not-allowed;\n    }\n"])), getBackgroundColor, function (_ref) {
  var maxHeight = _ref.maxHeight;
  return maxHeight && maxHeight !== "none" ? maxHeight : "none";
}, function (_ref2) {
  var minHeight = _ref2.minHeight;
  return minHeight && minHeight !== "none" ? minHeight : "none";
}, function (_ref3) {
  var themeMode = _ref3.themeMode;
  return "\n        ".concat(formInputTheme.padding.top.rest(themeMode), "px\n        6px \n        ").concat(formInputTheme.padding.bottom.rest(themeMode), "px\n        ").concat(formInputTheme.padding.default.rest(themeMode), "\n    ");
}, function (_ref4) {
  var themeMode = _ref4.themeMode;
  return formInputTheme.placeholderColor.rest(themeMode);
});
//# sourceMappingURL=TextAreaStyled.js.map